// extracted by mini-css-extract-plugin
export default {"background":"Login_background__dPmRz","shape":"Login_shape__mgDFU","login-form":"Login_login-form__Cv55M"};